import { render, staticRenderFns } from "./CastCrew.vue?vue&type=template&id=0d9fc35e&scoped=true&"
import script from "./CastCrew.vue?vue&type=script&lang=js&"
export * from "./CastCrew.vue?vue&type=script&lang=js&"
import style0 from "./CastCrew.vue?vue&type=style&index=0&id=0d9fc35e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9fc35e",
  null
  
)

export default component.exports